import {
  afterEveryRender,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  input,
  OnChanges,
  signal,
  SimpleChanges,
  viewChild,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'syn-truncated-content',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './syn-truncated-content.component.html',
  styleUrl: './syn-truncated-content.component.scss',
  imports: [MatButtonModule, MatIconModule],
})
export class SynTruncatedContentComponent implements OnChanges {
  constructor() {
    afterEveryRender({
      write: () => {
        if (this.disabled()) {
          if (this.showButton()) {
            this.showButton.set(false);
          }
          return this.showButton();
        }

        if (this._isContentOverflowing()) {
          this.showButton.set(true);
        }

        return this.showButton();
      },
    });
  }

  private readonly _baseFontSize = 16;

  public contentElement = viewChild<ElementRef>('content');

  /** input `truncatedHeight` should be given in rem. For an example `truncatedHeight="3rem"` */
  public truncatedHeight = input.required<string>();

  /** When true, content is never truncated and no expand toggle is shown. */
  public disabled = input<boolean>(false);

  protected currentHeight = signal<string>('');
  protected showButton = signal<boolean>(false);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['truncatedHeight'] || changes['disabled']) {
      this.setCurrentHeight(this.disabled() ? '' : this.truncatedHeight());
    }
  }

  protected setCurrentHeight(height?: string, event?: Event): void {
    this.currentHeight.set(height ?? 'auto');
    event?.stopPropagation();
  }

  private _isContentOverflowing(): boolean {
    if (!this.contentElement()) {
      return false;
    }

    const scrollHeight = this.contentElement()?.nativeElement.scrollHeight;
    const truncatedHeight =
      parseInt(this.truncatedHeight(), 10) * this._baseFontSize;
    return scrollHeight > truncatedHeight;
  }
}
